import { EnabledIconProps, IconProps } from './IconProps';

export const CloudIcon = ({
  className,
  height = 9,
  width = 11,
  enabled = false,
}: IconProps & EnabledIconProps) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 14 11"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.796 11H3.204C1.43 11 0 9.405 0 7.466 0 6.09.707 4.875 1.808 4.295 2.153 1.848 4.108 0 6.425 0c2.218 0 4.075 1.65 4.552 3.95C12.669 4.06 14 5.6 14 7.485 14 9.405 12.554 11 10.796 11z"
      fill={enabled ? '#2396FD' : '#B2B2B2'}
      fillRule="nonzero"
    />
  </svg>
);
